import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  NumberField,
  ReferenceField,
  ReferenceInput,
  TextField,
  TextInput,
} from 'react-admin';

const searchFilters = [
  <TextInput source="name@ilike" label="Name" resettable alwaysOn />,

  // <ReferenceInput source="profile_id" label="Email" reference="profiles" alwaysOn>
  //   <TextInput source="email" />
  // </ReferenceInput>,

  <TextInput source="funeral_id" label="Funeral ID" resettable alwaysOn />,
];

export const CommentsList = () => (
  <List
    filters={searchFilters}
    sort={{ field: 'id', order: 'DESC' }}
    perPage={50}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <NumberField source="id" />
      <TextField source="funeral_id" />
      <ReferenceField
        source="funeral_id"
        reference="funerals"
        label="Client name"
      >
        <ReferenceField
          source="deceased_client_id"
          label="Name"
          reference="clients"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
      </ReferenceField>
      <TextField source="name" />
      <ReferenceField source="profile_id" label="Email" reference="profiles">
        <TextField source="email" />
      </ReferenceField>{' '}
      <TextField source="text" />
      <BooleanField source="visible" />
      <DateField source="created_at" />
    </Datagrid>
  </List>
);
